// extracted by mini-css-extract-plugin
module.exports = {"feedLayout":"page_feedLayout__G5BPu","pageContainer":"page_pageContainer__HolCJ"};